import { render, staticRenderFns } from "./stockAccountCard.vue?vue&type=template&id=3b940e69&scoped=true"
import script from "./stockAccountCard.vue?vue&type=script&lang=js"
export * from "./stockAccountCard.vue?vue&type=script&lang=js"
import style0 from "./stockAccountCard.vue?vue&type=style&index=0&id=3b940e69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b940e69",
  null
  
)

export default component.exports